import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateListResource } from '../../../lib/query/invalidateResource';
import { createOfferingCategory } from '../api/offeringCategories';
import type { OfferingCategoryFormValues } from '../types';
import { notification } from 'antd';

export function useCreateOfferingCategory(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: OfferingCategoryFormValues) => createOfferingCategory(data),
    onSuccess: () => {
      notification.success({ message: 'Category created successfully' });
      invalidateListResource(queryClient, 'offering-categories');
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: () => {
      notification.error({ message: 'Failed to create category' });
    },
  });
}
